import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { useSelector } from "react-redux";

import { store, setIsAddPeripheralClicked, setSelectedRowData } from "../store";
import { store as userStore } from "@components/VerticalLayout/store";
import { UpdateResourceIp } from "@helpers/general";
import { getAuthorizationStates } from "@components/VerticalLayout/StyledSidebarMenu";
import { useAuthHeader } from "../../../../api/headersKeycloak";
import { useFetchGlobal } from "../../../../api/hooks";

import CashManagementActionColumn from "./CashManagementActionColumn";
import DropDownAction from "../DropDownAction";

type UseCashManagementProps = {
    rowData: any;
    selectedRows: any;
};

export function useCashManagement({ rowData, selectedRows }: UseCashManagementProps) {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();
    const { fetchGlobal } = useFetchGlobal();

    const { oneShop, userID, franchiseID, shopID } = useSnapshot(userStore);
    const { isAddPeripheralClicked } = useSnapshot(store);
    const authorizationList = useSelector(
        (state: any) => state.global.infoUser.profileAuthorization
    );
    const modify = getAuthorizationStates(
        "5590fe0f-69fc-9ff9-699d-d9a9defd12ad",
        authorizationList
    ).Modifie;

    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [
        isDataCashManagementUpdated,
        setIsDataCashManagementUpdated,
    ] = React.useState<boolean | number>(false);
    const [
        isConfirmationEditRunning,
        setIsConfirmationEditRunning,
    ] = React.useState<boolean>(false);
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [
        isAddNewCashManagementButtonClicked,
        setIsAddNewCashManagementButtonClicked,
    ] = React.useState(false);
    const [isEdited, setIsEdited] = React.useState<boolean>(false);
    const [shopId, setShopId] = React.useState<number>(
        oneShop ? shopID : rowData.shopId
    );
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const [editedData, setEditedData] = React.useState<any>([]);
    const [data, setData] = React.useState<any>([]);
    const [
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    ] = React.useState<boolean>(false);
    const [
        isModalDeleteAssociatePeripheralOpened,
        setIsModalDeleteAssociatePeripheralOpened,
    ] = React.useState<boolean>(false);
    const [inputDesignation, setInputDesignation] = React.useState<boolean>(false);
    const [inputMarque, setInputMarque] = React.useState<boolean>(false);
    const [inputIp, setInputIp] = React.useState<boolean>(false);

    const getArrayOfApplications = () => {
        let applications: any = [];
        selectedRows.forEach((elt: any) => {
            if (elt[t("Application")] !== "")
                applications.push(elt[t("Application")]);
        });
        return applications;
    };

    let applications = getArrayOfApplications();

    let arrayOfCustomColumns: { indexOFColumn: number; columnName: string; customJsx: React.ReactNode }[] = [];
    arrayOfCustomColumns.push({
        indexOFColumn: 999,
        columnName: t("Actions"),
        customJsx: (e: any) => (
            <CashManagementActionColumn
                rowData={rowData}
                element={e.selectedRow}
                isDataCashManagementUpdated={isDataCashManagementUpdated}
                selectedRows={selectedRows}
            />
        ),
    });
    arrayOfCustomColumns.push({
        indexOFColumn: 0,
        columnName: t("Designation"),
        customJsx: (e: any) => {
            return <div>{e.selectedRow[t("Designation")]}</div>;
        },
    });

    function customJsxComponent(e: any) {
        return (
            (e.selectedRow.original["Application"] !== "" ||
                e.selectedRow.original["Périphérique"] !== "") && (
                <div className="w-100 d-flex justify-content-center">
                    <DropDownAction
                        element={e}
                        setEditedData={setEditedData}
                        setInputIp={setInputIp}
                    />
                </div>
            )
        );
    }

    useEffect(() => {
        setSelectedRowData(rowData);
        setShopId(oneShop ? shopID : rowData.shopId);
    }, [oneShop, shopID, rowData]);

    useEffect(() => {
        UpdateResourceIp(userID, franchiseID, fetchGlobal);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        t,
        getAuthHeader,
        oneShop,
        userID,
        franchiseID,
        shopID,
        isAddPeripheralClicked,
        setIsAddPeripheralClicked,
        modify,
        isModalOpened,
        setIsModalOpened,
        isDataCashManagementUpdated,
        setIsDataCashManagementUpdated,
        isConfirmationEditRunning,
        setIsConfirmationEditRunning,
        filterActive,
        setLocalFilterActive,
        isAddNewCashManagementButtonClicked,
        setIsAddNewCashManagementButtonClicked,
        isEdited,
        setIsEdited,
        shopId,
        i18nextLng,
        editedData,
        setEditedData,
        data,
        setData,
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
        isModalDeleteAssociatePeripheralOpened,
        setIsModalDeleteAssociatePeripheralOpened,
        inputDesignation,
        setInputDesignation,
        inputMarque,
        setInputMarque,
        inputIp,
        setInputIp,
        applications,
        arrayOfCustomColumns,
        customJsxComponent,
    };
}
